import { useCallback } from "react";
import { QuackChatConfigResponse } from "@/components/quack-chat/QuackChatConfig.model";
import { OptionalFieldGroup } from "./FieldGroup";

interface AllowCloseAndOpenChatProps {
  chatSettings: QuackChatConfigResponse["chatSettings"];
  updateChatSettings: (
    chatSettings: Partial<QuackChatConfigResponse["chatSettings"]>
  ) => void;
}

export function AllowCloseAndOpenChat({
  chatSettings,
  updateChatSettings,
}: AllowCloseAndOpenChatProps) {
  const updateAllowCloseChat = useCallback(
    (enabled: boolean) => {
      updateChatSettings({ allowCloseChat: enabled });
    },
    [updateChatSettings]
  );

  const updateAllowOpenChat = useCallback(
    (enabled: boolean) => {
      updateChatSettings({ allowNewChat: enabled });
    },
    [updateChatSettings]
  );

  return (
    <>
      <OptionalFieldGroup
        label={"Allow Close Chat"}
        description={"Allow users to close the chat."}
        enabled={chatSettings.allowCloseChat ?? false}
        toggleEnabled={updateAllowCloseChat}
      />

      <OptionalFieldGroup
        label={"Allow Open Chat"}
        description={"Allow users to open a new chat."}
        enabled={chatSettings.allowNewChat ?? false}
        toggleEnabled={updateAllowOpenChat}
      />
    </>
  );
}
